import { deletedFilters } from "helpers/redux";
import React, { Component } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import * as source from "sources/books/drivers";
import List from "./list";
import Show from "./show";

export default class Drivers extends Component {
    componentWillUnmount() {
        this.props.clearParams("drivers", deletedFilters());
    }

    render() {
        const { match, location, history } = this.props;
        const rootUrl = `${match.path}/list`;
        const back = () => history.push(rootUrl);
        return (
            <div className="page-content">
                <Switch location={location}>
                    <Route exact path={`${match.path}/`} render={() => <Redirect to={rootUrl} />} />
                    <Route
                        exact
                        path={rootUrl}
                        render={() => (
                            <List
                                {...this.props}
                                isTable
                                transition="full"
                                title="Список водителей"
                                nofilter
                                source={source}
                            />
                        )}
                    />
                    <Route
                        path={`${rootUrl}/:id`}
                        render={(rest) => (
                            <Show {...rest} transition="full" title="Водитель" back={back} source={source} />
                        )}
                    />
                </Switch>
            </div>
        );
    }
}
